import { Component } from '@angular/core';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { AuthenticationService } from '@app/core/authentication/authentication.service';
import { DialogDeleteGenericComponent } from '@app/shared/components/dialog-delete-generic/dialog-delete-generic.component';
import { TrustedDevice, TrustedDevicesService } from '@app/shared/services/trusted-devices/trusted-devices.service';

@Component({
  standalone: false,
  selector: 'sbnb-authorized-devices-list',
  templateUrl: './authorized-devices-list.component.html',
  styleUrls: ['./authorized-devices-list.component.scss'],
})
export class AuthorizedDevicesListComponent {
  devicesState$ = this.trustedDevicesService.trustedDeviceState$;

  displayedColumns = ['name', 'this', 'country', 'ip', 'status', 'trusted', 'actions'];
  deviceUuid: string | null = null;

  constructor(
    private trustedDevicesService: TrustedDevicesService,
    private auth: AuthenticationService,
    private dialog: MatDialog
  ) {
    this.deviceUuid = this.auth.get2faNonce();

    this.fetchFromApi();
  }

  fetchFromApi() {
    this.trustedDevicesService.fetchTrustedDevicesFromApi();
  }

  revoke(device: TrustedDevice) {
    const dialog = this.dialog.open(DialogDeleteGenericComponent, {
      data: {
        action: 'Revoke',
        name: 'this device',
        identifier: device.derived_name,
        additionalText:
          'This will remove the device from the list of authorized devices. Future login attempts from this device will require two-factor authentication.',
      },
      maxWidth: '640px',
    });
    dialog.afterClosed().subscribe((result) => {
      if (result) {
        this.trustedDevicesService.revokeDevice(device.id);
      }
    });
  }
}
